import { render, staticRenderFns } from "./ShowCensoEscolarPage.vue?vue&type=template&id=505e8481"
import script from "./ShowCensoEscolarPage.vue?vue&type=script&lang=js"
export * from "./ShowCensoEscolarPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports